<h2 mat-dialog-title>{{ data.title || 'Add Mail Service' }}</h2>

<p class="subtitle">{{ data.subTitle }}</p>

<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Server"
      placeholder="Select server"
      type="autocomplete"
      [options]="filteredServers()"
      formControlName="server"
      [(searchText)]="serverSearchText"
    ></app-input-field>

    <app-input-field
      label="Website"
      placeholder="Select website"
      type="autocomplete"
      [options]="(websiteOptions$ | async) || []"
      formControlName="websiteId"
      [(searchText)]="websiteSearchText"
      [errorMessages]="{
        serviceExists: 'This website already has Mail Service in Vmax.',
      }"
    ></app-input-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">
    {{ data.primaryButtonText || 'Add Mail Service' }}
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
